/** Front-end mirror of backend command_room/calcs.py — same rules, for live preview. */

const n = (v) => (v === null || v === undefined || v === "" ? 0 : Number(v));
const has = (v) => v !== null && v !== undefined && v !== "";

export function computeEntry(f) {
  const rev = has(f.revenue) ? n(f.revenue) : null;
  const cogs = has(f.cogs) ? n(f.cogs) : null;
  const gross = rev !== null || cogs !== null ? (rev ?? 0) - (cogs ?? 0) : null;
  const opexFields = ["staff_cost", "rent", "utilities", "marketing", "other_opex"];
  const anyOpex = opexFields.some((k) => has(f[k]));
  const opex = anyOpex ? opexFields.reduce((s, k) => s + (has(f[k]) ? n(f[k]) : 0), 0) : null;
  const ebitda = gross !== null || opex !== null ? (gross ?? 0) - (opex ?? 0) : null;
  const gm_pct = rev && gross !== null ? gross / rev : null;
  const ebitda_pct = rev && ebitda !== null ? ebitda / rev : null;
  const budget_variance = ebitda !== null && has(f.budget_ebitda) ? ebitda - n(f.budget_ebitda) : null;
  return { ...f, gross_profit: gross, opex, ebitda, gm_pct, ebitda_pct, budget_variance };
}

export function fmtPct(r) {
  return r === null || r === undefined ? "—" : `${(r * 100).toFixed(1)}%`;
}

export function deltaPct(current, prior) {
  if (!prior || !current || prior === 0) return null;
  return (current - prior) / Math.abs(prior);
}
